module.exports = __webpack_public_path__ + "static/media/JP.1e4691a2.png";